const useLearningCueMediaFileName = function (key) {
  if (!key) {
    return ""
  }
  return key.replace(/[\w]+\/?[\d]+-/, "")
}

export default useLearningCueMediaFileName
